import { LockOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import { useState } from "react";
import AuthLayout from "../../../components/layout/AuthLayout";
import { getRoutes } from "../../../routes/Routes";

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    // TODO: call reset password API
  };

  return (
    <AuthLayout
      title="Reset Password"
      subtitle="Set a new password for your account."
      actionText="Remembered your password?"
      actionLabel="Log In"
      actionLink={getRoutes().login.route()}
    >
      <Form layout="vertical" size="large" onFinish={onFinish}>
        <Form.Item
          name="password"
          label="New Password"
          rules={[
            { required: true, message: "Enter your new password" },
            { min: 6, message: "Minimum 6 characters" },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Enter new password"
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          dependencies={["password"]}
          rules={[
            { required: true, message: "Confirm your password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value)
                  return Promise.resolve();
                return Promise.reject(new Error("Passwords do not match"));
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Confirm new password"
          />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          block
          loading={loading}
          size="large"
          className="mt-2"
        >
          Reset Password
        </Button>
      </Form>
    </AuthLayout>
  );
};

export default ResetPassword;
